// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { useReserveInstrumentConfiguration } from './registry/useInstrumentConfiguration';

export const useBridgeOperatorParty = (): UseQueryResult<string, string> => {
  const instrumentConfigQuery = useReserveInstrumentConfiguration();
  return {
    ...instrumentConfigQuery,
    data: instrumentConfigQuery.data?.payload.provider,
  } as UseQueryResult<string, string>;
};
